<oaibox-warning-message-card gradient="warning" (confirm$)="resetRanConfiguration()" (cancel$)="cancel()">
  <div messageTitle>Are you sure you want to reset the machine configuration?</div>
  <div messageBody class="p-g pb-0">
    <div class="tenant-name">{{tenant?.clientName}}</div>
    <div class="under-label">{{tenant?.clientDescription}}</div>
  </div>
</oaibox-warning-message-card>
